import { Button, styled } from "@mui/material";
import { ICustomButtonProps, getSizeStyles } from "./CustomBtnResources";

const SecondaryButton = ({
  disabled,
  children,
  onClick,
  style,
  size = "large",
  nativeType,
  type = "primary",
  loading = false,
  loadingText = "Loading...",
  preImg,
  postImg,
}: ICustomButtonProps) => {
  const SecButton = styled(Button)`
    && {
      text-transform: none;
      border-radius: 30px;
      font-weight: 500;
      border: 1px solid #fdd649;
      width: auto;
      color: #fdd649;
      padding: ${getSizeStyles(size, type).padding};
      font-size: ${getSizeStyles(size, type).fontSize};
      line-height: ${getSizeStyles(size, type).lineHeight};
      &:hover {
        background-color: #25231a;
        border: 1px solid #fee38b;
        color: #fee38b;
      }
      &:active {
        background-color: #302c19;
        border: 1px solid #feefc3;
        color: #feefc3;
      }
      &:disabled {
        background-color: transparent;
        border: 1px solid #696969;
        color: #696969;
      }
    }
  `;

  return (
    <SecButton
      type={nativeType}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {!loading && preImg && typeof preImg === "string" ? (
        <img
          src={preImg}
          alt="preImg"
          style={{ display: "flex", marginRight: 8 }}
          width={size === "large" || type === "onBoarding" ? 24 : 18}
          height={size === "large" || type === "onBoarding" ? 24 : 18}
        />
      ) : (
        !loading &&
        preImg && <div style={{ display: "flex", marginRight: 8 }}>{preImg}</div>
      )}
      {!loading ? children : loadingText}
      {!loading && postImg && typeof postImg === "string" ? (
        <img
          src={postImg}
          style={{ display: "flex", marginLeft: 8 }}
          alt="postImg"
          width={size === "large" ? 24 : 18}
          height={size === "large" ? 24 : 18}
        />
      ) : (
        !loading &&
        postImg && (
          <div style={{ display: "flex", marginLeft: 8 }}>{postImg}</div>
        )
      )}
    </SecButton>
  );
};

export default SecondaryButton;
